import $ from 'jquery';
import BurgerBtn from './lhs/transverse/burgerBtn';
import SearchPanel from './lhs/transverse/searchPanel';
import NavPanelDesktop from './lhs/transverse/navPanelDesktop';
import NavPanelMobile from './lhs/auth/navPanelMobile';
import {MARKET} from 'Utils/market.constants';

const SELECTOR = {
    HEADER_ROOT: '.js-header-lhs-auth',
    MAIN_CONTENT: '.dcw_main',
    MAIN_CONTENT_RSP: '.rsp_main',
    BURGER_BTN: '.js-header-burger',
    GLOBAL_BURGER: '.js-burger-content',
    DESKTOP_PANEL_SEACH: '.js-desktop-panel-search',
    MOBILE_PANEL_SEACRH: '.js-nav-search',
    CLOSE_BTN: '.js-mobile-close-menu',
    BURGER_CONTENT: '.js-login-box'
};

const PREFIX = {
    GSA: 'search-gsa'
}

// COMPONENTS
var burgerBtn, navPanelDesktop, navPanelMobile, panelSearch = null;
let domCache;

/*
    This function is used to initialized Desktop context for the navigation LHS
 */
export function initHeaderLhsAuthDesktop() {
    panelSearch = new SearchPanel(SELECTOR.DESKTOP_PANEL_SEACH, PREFIX.GSA, false);
    burgerBtn = new BurgerBtn(SELECTOR.BURGER_BTN, SELECTOR.GLOBAL_BURGER, SELECTOR.CLOSE_BTN);
    burgerBtn.init();

    navPanelDesktop = new NavPanelDesktop();
    navPanelDesktop.init();

    domCache = getDomCache(SELECTOR.HEADER_ROOT);
}

/*
    This function is used to initialized Mobile context for the navigation LHS
 */
export function initHeaderLhsAuthMobile() {
    panelSearch = new SearchPanel(SELECTOR.MOBILE_PANEL_SEACRH, PREFIX.GSA, true);
    burgerBtn = new BurgerBtn(SELECTOR.BURGER_BTN, SELECTOR.GLOBAL_BURGER);
    burgerBtn.init();

    navPanelMobile = new NavPanelMobile();
    navPanelMobile.init();

    domCache = getDomCache(SELECTOR.HEADER_ROOT);

    if (MARKET.CODE === 1) {
        marginContent();
    }
}

function getDomCache(SelectorHeaderRoot) {
    return {
        headerRoot: document.querySelector(SelectorHeaderRoot)
    };
}

function marginContent() {
    var marginHead = domCache.headerRoot.clientHeight + 24;

    // Case with new classes rsp main
    var mainContent = document.querySelector(SELECTOR.MAIN_CONTENT);
    if (!mainContent) {
        mainContent = document.querySelector(SELECTOR.MAIN_CONTENT_RSP);
    }


    mainContent.style.marginTop = marginHead + "px";
}


// WEBPACK FOOTER //
// ./src/components/header/headerLhsAuth.js